import {Box, Button, Typography} from "@mui/material";
import React, {ReactNode} from "react";
import Image from "next/image";
import Container from "@mui/material/Container";
import {useRouter} from "next/navigation";

export default function NoResult({
                                     message = "نتیجه‌ای یافت نشد",
                                     imageSrc = "/images/icons/no-result-found.svg",
                                     imageComponent,
                                     description,
                                     children,
                                     showBackButton = false,
                                     backButtonText = "بازگشت",
                                     imageStyle
                                 }: {
    message?: string;
    description?: string;
    imageSrc?: string;
    children?: ReactNode;
    imageComponent?: ReactNode;
    showBackButton?: boolean;
    backButtonText?: string;
    imageStyle?: React.CSSProperties;
}) {
    const router = useRouter();

    return (
        <Container >
            <Box
                my = {0}
                gap = {1.5}
                minHeight = {{md: '70vh', xs: "50vh"}}
                display = "flex"
                flexDirection = "column"
                justifyContent = "center"
                alignItems = "center"
                textAlign = "center"
            >
                {imageComponent ? (
                    imageComponent
                ) : (
                    <Image
                        src = {imageSrc}
                        alt = "عکس مربوط به پیام خطا"
                        height = {250}
                        width = {250}
                        style = {{ objectFit:"contain" ,...imageStyle}}
                    />
                )}

                <Typography
                    // color="primary.button"
                    gutterBottom
                    fontWeight = {400}
                    fontSize = {18}
                >
                    {message}
                </Typography >

                {description && <Typography >{description}</Typography >}

                {children}

                {showBackButton && (
                    <Button variant = "outlined" onClick = {() => router.back()} sx = {{mt: 4}} >
                        {backButtonText}
                    </Button >
                )}

            </Box >

        </Container >

    );
};

